import type { DrillLocation, ExplorationSelection } from '../../types/exploration';
import { isDrillLocationEmpty } from './drillLocation';

export interface CanDrillUpState {
  drillPath: DrillLocation;
  selectedNode: ExplorationSelection;
  /** Session visit stack — non-empty means canvas out can navigate(-1) like Back. */
  drillHistoryLength?: number;
}

export function canDrillUp(state: CanDrillUpState): boolean {
  return (
    !isDrillLocationEmpty(state.drillPath) ||
    state.selectedNode != null ||
    (state.drillHistoryLength ?? 0) > 0
  );
}
